import { ValidationError } from 'jsonschema'
import { humanFileSize } from '../../utils/humanFileSize'

export const SCHEMA_KEYS = {
  PREDMET: 'predmet',
  TEXT: 'text',
  CISLO_JEDNACI: 'cisloJednaci',
  KRITERIA: 'kriteria',
  PRILOHY: 'prilohy',
  POCET_PRILOH: 'pocetPriloh',
  VELIKOST_PRILOH: 'velikostPriloh',
}

const labelMap = {
  [SCHEMA_KEYS.PREDMET]: 'Předmět',
  [SCHEMA_KEYS.TEXT]: 'Text',
  [SCHEMA_KEYS.CISLO_JEDNACI]: 'Číslo jednací',
  [SCHEMA_KEYS.POCET_PRILOH]: 'Počet příloh',
  [SCHEMA_KEYS.VELIKOST_PRILOH]: 'Velikost příloh'
}

export const SCHEMA_VALIDATE_TYPE = {
  REQ: 'required',
  EX_MIN: 'exclusiveMinimum',
  EX_MAX: 'exclusiveMaximum',
  MIN_L: 'minLength',
  MAX_L: 'maxLength',
  MIN: 'minimum',
  MAX: 'maximum',
  MIN_ITEMS: 'minItems',
  MAX_ITEMS: 'maxItems',
  MULPTIPLE_OF: 'multipleOf',
}

const ARG_SUBS_STR = '{arg_sub_str}'
const LABEL_SUBS_STR = '{label_sub_str}'

const VALIDATE_MSGS = {
  [SCHEMA_VALIDATE_TYPE.REQ]: `Položka "${LABEL_SUBS_STR}" je povinná`,
  [SCHEMA_VALIDATE_TYPE.EX_MIN]: `Hodnota "${LABEL_SUBS_STR}" musí být větší než ${ARG_SUBS_STR}`,
  [SCHEMA_VALIDATE_TYPE.EX_MAX]: `Hodnota "${LABEL_SUBS_STR}" musí být menší  než ${ARG_SUBS_STR}`,
  [SCHEMA_VALIDATE_TYPE.MIN_L]: `"${LABEL_SUBS_STR}" musí obsahovat alespoň ${ARG_SUBS_STR} znaků`,
  [SCHEMA_VALIDATE_TYPE.MAX_L]: `"${LABEL_SUBS_STR}" nesmí přesáhnout ${ARG_SUBS_STR} znaků`,
  [SCHEMA_VALIDATE_TYPE.MIN]: `"${LABEL_SUBS_STR}" musí být alespoň ${ARG_SUBS_STR}`,
  [SCHEMA_VALIDATE_TYPE.MAX]: `"${LABEL_SUBS_STR}" nesmí překročit ${ARG_SUBS_STR}`,
  [SCHEMA_VALIDATE_TYPE.MIN_ITEMS]: `"${LABEL_SUBS_STR}" musí obsahovat alespoň ${ARG_SUBS_STR} položek`,
  [SCHEMA_VALIDATE_TYPE.MAX_ITEMS]: `"${LABEL_SUBS_STR}" nesmí obsahovat více než ${ARG_SUBS_STR} položek`,
  [SCHEMA_VALIDATE_TYPE.MULPTIPLE_OF]: `"${LABEL_SUBS_STR}" musí být násobek ${ARG_SUBS_STR}`,
}

export const proccesValidErr = (err: ValidationError, labelMapsCrit: { [key: string]: string }) => {
  const pathParts = [...err.path]

  if (err.name === SCHEMA_VALIDATE_TYPE.REQ) {
    pathParts.push(err.argument)
  }
  const name = pathParts.slice(-1)[0]

  let localArgument = err.argument
  const localLabel = labelMap[name] ?? labelMapsCrit[name] ?? name
  if (name === SCHEMA_KEYS.VELIKOST_PRILOH) {
    localArgument = `${localArgument.toLocaleString()} bajtů (${humanFileSize(localArgument)})`
  }
  const msg = VALIDATE_MSGS[err.name]?.replace(ARG_SUBS_STR, localArgument).replace(LABEL_SUBS_STR, localLabel) ?? err.message

  return ({
    path: pathParts.join('.'),
    name: err.name,
    message: msg,
    fullMessage: err.message,
    stack: err.stack,
  })
}
